import { Schema } from 'rsuite'

const { StringType, NumberType } = Schema.Types

export const BrandFormValidationModel = Schema.Model({
  name: StringType().isRequired('Заполните название'),
  slug: StringType()
    .pattern(
      /^[a-z0-9\-]+$/,
      'Некорректное значение! Допустимые символы: -, a..z, 0..9'
    )
    .isRequired('Заполните поле!'),
  logo_id: NumberType().isRequired('Загрузите логотип'),
  selectedDefaultShopId: NumberType('Выберите магазин по умолчанию').isRequired(
    'Выберите магазин по умолчанию!'
  )
})
